import { createPortal } from "react-dom";
import { SideModal } from "shared";
import TransactionsTable from "features/companies/TransactionsSideModal/components/TransactionsTable";
import { UserAssetRow } from "hooks/investments/GetUserAssetsAdminHook";

interface ShareTransactionsSideModalProps {
  isOpen: boolean;
  onClose: () => void;
  item: UserAssetRow | null;
  ownerName?: string | null;
}

const ShareTransactionsSideModal: React.FC<ShareTransactionsSideModalProps> = ({
  isOpen,
  onClose,
  item,
  ownerName,
}) => {
  const company = item
    ? {
        uuid: item.uuid,
        name: item.name,
        shareId: item.shareId,
        sharesCount: item.sharesCount,
        currencyUuid: item.currencyUuid,
        origin: item.origin,
      }
    : null;

  return createPortal(
    <SideModal
      isOpen={isOpen}
      onClose={onClose}
      title="Lista transakcji"
      subtitle={
        <>
          <p>
            <b>Spółka:</b> {item?.name || "-"} | <b>Klient:</b>{" "}
            {ownerName || "-"}
          </p>
          <p className="transactions-side-modal__counter">
            Obecna ilość sztuk: <b>{item?.sharesCount ?? "—"}</b>
          </p>
        </>
      }
      className="company-info-modal wide"
    >
      <TransactionsTable company={company as any} isAdmin isOwn={false} />
    </SideModal>,
    document.body
  );
};

export default ShareTransactionsSideModal;
